import { useEffect, useState } from "react";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { IAddressBookListItem } from "../../Interfaces/addressbook";
import { getAddressBooks } from "../../Requests/addressbook";
import AddForm from "./AddForm";
import { CommonTableUI } from "../../Tables/TableTemplate/common";
import { Additional } from "./Additional";

const Addressbook = () => {
  const [addressbooks, setAddressbooks] = useState(
    [] as IAddressBookListItem[]
  );
  const [loading, setLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    fetchAddressBooks();
  }, []);
  useEffect(() => {
    if (refreshFlag) fetchAddressBooks();
  }, [refreshFlag]);

  function fetchAddressBooks() {
    setLoading(true);
    getAddressBooks()
      .then((resp) => setAddressbooks(resp))
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
        setRefreshFlag(false);
      });
  }

  return (
    <div className="flex flex-row justify-start items-start gap-2 px-4 mt-8">
      <AddForm refreshTable={() => setRefreshFlag(true)} />
      {addressbooks && addressbooks.length ? (
        <CommonTableUI<IAddressBookListItem>
          reports={{
            translatedHeaders: [
              {
                headerName: "title",
                translateHeaderName: "عنوان",
                positionTypeStr: "FirstPage",
              },
              {
                headerName: "address",
                translateHeaderName: "آدرس",
                positionTypeStr: "FirstPage",
              },
              {
                headerName: "contactTypeStr",
                translateHeaderName: "نوع ارتباط",
                positionTypeStr: "FirstPage",
              },
              {
                headerName: "notificationBrokerTypeStr",
                translateHeaderName: "نوع notificationBroker",
                positionTypeStr: "FirstPage",
              },
              {
                headerName: "lastModifyStr",
                translateHeaderName: "آخرین تغییر",
                positionTypeStr: "FirstPage",
              },
            ],
            report: addressbooks?.map((a, i) => ({
              ...a,
              id: a.id,
              row: i + 1,
            })),
          }}
          AdditionalBody={Additional}
          onAction={() => setRefreshFlag(true)}
          withSelect
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default Addressbook;
